export default {
  data: () => ({
    swrResponse: '',
    swrResponseError: '',
  }),
  methods: {
    useSwr(key, req, cb = null) {
      const item = sessionStorage.getItem(key);
      if (item) {
        if (this.whenSwrResponse) {
          this.whenSwrResponse(JSON.parse(item));
        }
      }

      this.swrFetch(req, cb, key);
    },
    swrFetch(req, cb, key) {
      req()
        .then((res) => {
          this.swrResponse = res;
          sessionStorage.setItem(key, JSON.stringify(res));
        })
        .catch((err) => {
          this.swrResponseError = err;
        })
        .finally(() => {
          if (this.whenSwrResponse) {
            this.whenSwrResponse(
              this.swrResponse,
              this.swrResponseError,
            );
          }
          if (cb) {
            cb();
          }
        });
    },
  },
};
